module.exports = __webpack_public_path__ + "img/elementheights_jasa.943d8855.png";